import Link from "next/link";
import Image from "next/image";
import { MapPin } from "lucide-react";
import { TEST_CENTER_PATH } from "@/lib/route-layout";

/**
 * 좌측 사이드바 최상단 "정처기 실기 시험장 찾기" 홍보 배너 (전체 article 셸 공통).
 *
 * 전체가 단일 링크인 컴팩트 카드 — 리사이즈 pane(지도/목차·점수 등) 위에 `shrink-0`
 * 고정 높이로 얹힌다(아래 pane 들의 `flex-1` 레이아웃·스크롤은 그대로 유지).
 *
 * 색상은 dark-mode-colors.md 규칙대로 light/dark 페어를 명시한 연한 amber 틴트 카드
 * (브랜드 앰버 톤, §2/§4-4-1 "연한 틴트 카드" 패밀리). 시험장 페이지(`jcg-test-center`)는
 * 자체 `TestCenterShell` 을 쓰므로 ArticleShell 좌측에는 절대 노출되지 않아 self-link 걱정 없음.
 */
export default function TestCenterBanner() {
  return (
    <Link
      href={TEST_CENTER_PATH}
      className="group flex shrink-0 items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 shadow-sm transition-colors hover:border-amber-300 hover:bg-amber-100/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-background dark:border-amber-900 dark:bg-amber-950/40 dark:hover:border-amber-700 dark:hover:bg-amber-950/70"
    >
      <Image
        src="/exam-registration/jcg-test-center/test-center_gamza.webp"
        alt=""
        aria-hidden="true"
        width={40}
        height={40}
        className="h-10 w-10 shrink-0 object-contain motion-safe:transition-transform motion-safe:group-hover:scale-105"
      />
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-1 text-[13.5px] font-bold text-amber-800 dark:text-amber-200">
          <MapPin
            className="h-3.5 w-3.5 shrink-0 text-amber-600 dark:text-amber-400"
            aria-hidden="true"
          />
          <span className="truncate">정처기 실기 시험장 찾기</span>
        </span>
        <span className="mt-0.5 block text-[11.5px] leading-snug text-amber-700/90 dark:text-amber-300/80">
          지도로 우리 동네 시험장 확인
        </span>
      </span>
    </Link>
  );
}
